// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"order-adjustment.column"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M7 9L4 12L7 15M13 4V20M20.75 12H5.25M19 9L22 12L19 15","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const OrderAdjustmentColumnIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'order-adjustment-column',
    ref,
    icon: element,
  },
));

OrderAdjustmentColumnIcon.displayName = 'OrderAdjustmentColumnIcon';

export default OrderAdjustmentColumnIcon;
